module.exports = __webpack_public_path__ + "static/media/dracotizianaterenzi.780241f8.png";